var _style, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#34A853;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#34A853;stroke:#34A853;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#34A853;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,7.2C10.7,7.1,10.7,7,10.6,7L6.1,5.2c-0.2-0.1-0.5,0-0.7,0.1C5.2,5.5,5.1,5.8,5.2,6.1L7,10.6 c0,0,0.1,0.1,0.2,0.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,10.8C7.3,10.9,7.3,11,7.4,11l4.5,1.8c0.2,0.1,0.5,0,0.7-0.1c0.2-0.2,0.2-0.5,0.1-0.7L11,7.4 c0,0-0.1-0.1-0.2-0.2L7.2,10.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9,
    cy: 9,
    r: 7.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassAlt);
export default __webpack_public_path__ + "static/media/compass-alt.e511a74a94ac5311bfc479b7e1ad9b9b.svg";
export { ForwardRef as ReactComponent };